import React from 'react'
import { useNavigate } from 'react-router-dom'
import mainicon from '../assets/finalicon.svg'
import Star from '../components/star'
import businessman from '../assets/businessman.png'
import { Helmet } from 'react-helmet-async'

export default function Businesspage({selectedLanguage}) {
  const navigate = useNavigate()

  return (
    <div className='h-auto w-full bg-[#f3f3f3] overflow-hidden flex flex-col'>


      <Helmet>
  {/* The Authority Title for B2B */}
  <title>Sitemanifest for Business | Verified Reviews & Social Proof Widget</title>

  {/* Description focused on ROI and Trust */}
  <meta 
    name="description" 
    content="Turn customer trust into growth. Sitemanifest for Business provides the only unfakeable review widget that converts genuine customer feedback into measurable sales growth." 
  />

  {/* Robots & Canonical */}
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://sitemanifest.com/business" />

  {/* Open Graph - Targeted at Business Owners sharing on LinkedIn/Slack */}
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://sitemanifest.com/business" />
  <meta property="og:title" content="Sitemanifest for Business: Proof Right Where the Decision Happens" />
  <meta property="og:description" content="Embed your verified reputation directly into your sales flow with our high-performance widget." />
  <meta property="og:image" content="https://sitemanifest.com/og-business.png" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Sitemanifest | Verified Social Proof for Business" />
  <meta name="twitter:description" content="Stop leaving your reputation to chance. Capture, manage, and showcase the feedback that moves the needle." />
</Helmet>

      <section className='w-full relative flex flex-col h-[360px] lg:h-[450px] xs:h-[440px] xl:h-[500px] 2xl:h-[650px] overflow-hidden bg-greentoblue bg-opacity-90'>
        <div className='w-full flex flex-col pt-[60px] items-center mt-[24px] lg:mt-[40px] 2xl:mt-[70px] xl:gap-[40px] xs:gap-[32px] ip:gap-[20px] gap-[12px] z-10'>
          <h1 className='font-staat text-white 2xl:text-[48px] text-[14px] tracking-[8px] max-w-[300px] lg:max-w-[420px] xs:text-[24px] xs:max-w-[378px] text-center lg:text-[26px] xl:max-w-[500px] xl:text-[32px]'>
            Convert Genuine Customer Reviews into Growth
          </h1>
          <h2 className='font-staat font-regular 2xl:text-[24px] text-white text-[12px] xl:text-[18px] 2xl:leading-[30px] opacity-80 tracking-[3px] leading-[16px] text-center max-w-[294px] xs:max-w-full'>
            Uncover What Your Most Valuable Customers Think
          </h2>
        </div>

        <div className='w-full flex flex-col items-center xs:mt-[41px] mt-[21px] xs:gap-[35px] 2xl:gap-[40px] gap-[28px] z-10'>
          <button onClick={() => navigate('/business/signup')} className='font-staat text-center text-[12px] 2xl:text-[18px] xs:text-[14px] tracking-[3px] text-black h-[40px] rounded-[4px] 2xl:w-[346px] 2xl:h-[53px] bg-white xs:w-[255px] w-[215px] hover:bg-gray-100 transition-colors uppercase'>
            register your business
          </button>
          <button onClick={() => navigate('/business/login')} className='font-staat text-center text-[12px] 2xl:text-[18px] xs:text-[14px] tracking-[3px] text-black h-[40px] rounded-[4px] 2xl:w-[196px] 2xl:h-[53px] bg-white w-[162px] hover:bg-gray-100 transition-colors uppercase'>
            Log in
          </button>
        </div>
      </section>

      {/* --- WIDGET PROOF SECTION --- */}
      <section className="w-full mt-[60px] 2xl:max-w-[1440px] 2xl:mx-auto lg:mt-[120px] flex flex-col xl:items-start xl:px-[80px] items-center px-[18px] 2xl:px-[40px]">
        <div className="flex flex-col items-center xl:items-start xl:text-start text-center mb-[50px]">
          {/* Changed to H2 for SEO hierarchy */}
          <h2 className="text-[28px] lg:text-[40px] tracking-tight font-poppins font-bold text-[#111111] leading-[1.1]">
            Proof, Right Where the <span className="text-[#1C6065]">Decision Happens.</span>
          </h2>
          <p className="mt-4 font-poppins text-[14px] lg:text-[16px] text-gray-600 max-w-[800px] leading-relaxed">
            Don’t make your customers go looking for proof—bring it to them. Our lightweight, 
            high-performance widget embeds your verified reputation directly into your sales flow.
          </p>
        </div>

       <div className="flex flex-col xl:items-center xl:mx-auto gap-[40px] w-full max-w-[1100px]">
  
  {/* 1. LIGHT THEME ROW (Standard Border Logic) */}
  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 justify-items-center w-full" aria-hidden="true">
    
    {/* Summary Card Light */}
    <div className="w-full max-w-[340px] h-[220px] p-6 flex flex-col items-center justify-center rounded-[16px] border border-[#E5E5E5] bg-white shadow-sm hover:shadow-md transition-shadow">
      <span className="text-black font-poppins text-[22px] font-semibold">Great</span>
      <div className="flex flex-row gap-1 h-[30px] my-3">
        {[...Array(5)].map((_, i) => <Star key={i}  bgColor={'bg-five'} boxwidth="w-[30px]" boxheight="w-[30px]" width="w-[18px]" />)}
      </div>
      <span className="text-gray-600 font-poppins text-[13px] mb-4">4.9 Based on 250 Reviews</span>
      <div className="flex items-center gap-2 pt-4 border-t w-full justify-center">
        <span className="font-staat text-[16px] tracking-[3px]">SITEMANIFEST</span>
      </div>
    </div>

    {/* Detail Card 1 Light */}
    <div className="w-full max-w-[340px] h-[220px] p-6 flex flex-col rounded-[16px] border border-[#E5E5E5] bg-white shadow-sm">
      <div className="flex justify-between items-center mb-3">
        <span className="font-poppins font-semibold text-[14px]">Luca F.</span>
        <span className="text-[10px] text-gray-400">JUL 19, 2025</span>
      </div>
      <div className="flex gap-[2.21px] h-[20px] mb-3">
        {[...Array(5)].map((_, i) => <Star key={i} bgColor={'bg-five'} boxwidth="w-[20px]" boxheight="w-[20px]" width="w-[12px]" />)}
      </div>
      <span className="font-poppins font-bold text-[14px] mb-1 block">Absolute Game Changer</span>
      <p className="text-[12px] text-gray-600 leading-snug">
       Hours of manual work have been replaced by a completely transformed workflow. This dashboard is fast, intuitive, and manages heavy data loads without any of the lag I experienced before.
      </p>
    </div>

    {/* Detail Card 2 Light */}
    <div className="hidden xl:flex w-full max-w-[340px] h-[220px] p-6 flex-col rounded-[16px] border border-[#E5E5E5] bg-white shadow-sm">
      <div className="flex justify-between items-center mb-3">
        <span className="font-poppins font-semibold text-[14px]">Sophia P.</span>
        <span className="text-[10px] text-gray-400">FEB 21, 2025</span>
      </div>
      <div className="flex gap-[2.21px] h-[20px] mb-3">
        {[...Array(5)].map((_, i) => <Star key={i} bgColor={'bg-five'}  boxwidth="w-[20px]" boxheight="w-[20px]" width="w-[12px]" />)}
      </div>
      <span className="font-poppins font-bold text-[14px] mb-1 block">Seamless and Professional</span>
      <p className="text-[12px] text-gray-600 leading-snug">
        Transitioning to this platform was our best decision this year. The polished UI builds massive client confidence, while the intuitive design makes navigation a breeze.
      </p>
    </div>
  </div>

  {/* 2. DARK THEME ROW (Mirror Alignment Fix) */}
  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 justify-items-center w-full" aria-hidden="true">
    
    {/* Summary Card Dark */}
    <div className="w-full max-w-[340px] h-[220px] p-6 flex flex-col items-center justify-center rounded-[16px] border border-transparent bg-[#1A1A1A] shadow-xl">
      <span className="text-white font-poppins text-[22px] font-semibold">Great</span>
      <div className="flex flex-row h-[30px] gap-1 my-3">
        {[...Array(5)].map((_, i) => <Star key={i}  bgColor={'bg-five'} boxwidth="w-[30px]" boxheight="w-[30px]" width="w-[18px]" />)}
      </div>
      <span className="text-gray-400 font-poppins text-[13px] mb-4">4.9 Based on 250 Reviews</span>
      <div className="flex items-center gap-2 pt-4 border-t border-gray-700 w-full justify-center">
        <img className="w-[20px]" src={mainicon} alt="" role="presentation" />
        <span className="font-staat text-[16px] tracking-[3px] text-white">SITEMANIFEST</span>
      </div>
    </div>

    {/* Detail Card 1 Dark */}
    <div className="w-full max-w-[340px] h-[220px] p-6 flex flex-col rounded-[16px] border border-transparent bg-[#1A1A1A] shadow-xl">
      <div className="flex justify-between items-center mb-3">
        <span className="font-poppins font-semibold text-[14px] text-white">Emma D.</span>
        <span className="text-[10px] text-gray-500">March 04, 2025</span>
      </div>
      <div className="flex gap-[2.21px] h-[20px] mb-3">
        {[...Array(5)].map((_, i) => <Star key={i}  bgColor={'bg-five'} boxwidth="w-[20px]" boxheight="w-[20px]" width="w-[12px]" />)}
      </div>
      <span className="font-poppins font-bold text-[14px] mb-1 text-white block">Highly recommend for pros</span>
      <p className="text-[12px] text-gray-400 leading-snug">
        If you care about efficiency, you need this. The automation features alone are worth the price. It’s rare to find a tool that balances deep technical power with a user-friendly design.
      </p>
    </div>

    {/* Detail Card 2 Dark */}
    <div className="hidden xl:flex w-full max-w-[340px] h-[220px] p-6 flex-col rounded-[16px] border border-transparent bg-[#1A1A1A] shadow-xl">
      <div className="flex justify-between items-center mb-3">
        <span className="font-poppins font-semibold text-[14px] text-white">Roberto N.</span>
        <span className="text-[10px] text-gray-500">JAN 15, 2025</span>
      </div>
      <div className="flex gap-[2.21px] h-[20px] mb-3">
        {[...Array(5)].map((_, i) => <Star  bgColor={'bg-five'} key={i} boxwidth="w-[20px]" boxheight="w-[20px]" width="w-[12px]" />)}
      </div>
      <span className="font-poppins font-bold text-[14px] mb-1 text-white block">Supporto e qualità eccellenti</span>
      <p className="text-[12px] text-gray-400 leading-snug">
        Oltre alla piattaforma che funziona a meraviglia, devo fare un plauso all'assistenza. Hanno risposto a ogni mio dubbio in tempo reale. È raro trovare un servizio così curato nei minimi dettagli.
      </p>
    </div>
  </div>
</div>
      </section>

      {/* --- GREENISH FEATURE DIV --- */}
      <section className='w-full xs:px-[32px] mt-[100px] sp:mt-[125px] xs:mt-[50px] lg:mt-[75px] xl:px-[64px] 2xl:max-w-[1440px] 2xl:mx-auto'>
        <div className='w-full flex flex-col xs:rounded-[5px] xs:items-start xs:justify-between xs:flex-row-reverse bg-greendivsec xs:pr-[200px] lg:pr-[300px] 2xl:pr-[400px] relative pt-[35px] pb-[10px] xs:pt-[20px] xs:pb-[15px] px-[21px] mt-[38px] xl:mt-[50px] 2xl:mt-[64px] gap-[30px]'>
          <h2 className='font-staat text-[18px] font-regular relative z-10 text-white tracking-[3px] leading-[32px] max-w-[130px] xs:text-[32px] lg:text-[35px] lg:mt-[20px] xl:mt-0 xs:leading-[49px] xs:tracking-[3px] xl:text-[35px] xl:leading-[60px]'>
            Establish Customer Confidence with SITEMANIFEST
          </h2>
          <div className='flex flex-col p-[11px] xs:p-0 lg:p-[14px] xs:bg-transparent relative max-w-[280px] lg:max-w-[392px] xl:max-w-[530px] xs:max-w-[310px] xs:gap-[30px] z-10 bg-[#4A8187] gap-[10px]'>
            <p className='font-poppins text-[12px] tracking-[3px] font-medium text-white xl:text-[16px] lg:text-[14px]'>Built on authenticity and clear communication, Sitemanifest is the preferred hub for genuine customer testimonials.</p>
            <p className='font-poppins text-[12px] tracking-[3px] font-regular text-white xl:text-[16px] lg:text-[14px]'>By showcasing verified user experiences, companies utilize Sitemanifest to confirm their credibility.</p>
          </div>
          <img className='absolute bottom-0 z-5 -right-[40px] xs:-right-[15px] xs:w-[140px] lg:w-[165px]' src={businessman} alt="" role="presentation"/>
        </div>
      </section>

      {/* --- CTA SECTION --- */}
      <section className='w-full flex flex-col mt-[80px] lg:mt-[120px] px-[16px] xs:px-[64px] items-center text-center'>
        <h2 className='font-staat text-[#111111] text-[32px] lg:text-[48px] tracking-[2px] leading-tight mb-6 uppercase'>
          Turn Praise into <span className="text-[#1E7D6B]">Predictable Growth</span>
        </h2>
        <p className='font-poppins font-light text-[15px] lg:text-[18px] text-gray-600 max-w-[750px] leading-relaxed mb-10'>
          Stop leaving your reputation to chance. Create a Sitemanifest business account to <strong>capture, manage, and showcase</strong> the feedback that actually moves the needle.
        </p>
        <button 
          onClick={() => navigate('/business/signup')}
          className='group flex items-center justify-center bg-[#1E7D6B] text-white rounded-[6px] font-poppins font-semibold text-[14px] w-[280px] h-[64px] tracking-[2px] hover:bg-[#165f52] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-1'
        >
          CREATE AN ACCOUNT
          <span className="ml-3 group-hover:translate-x-1 transition-transform" aria-hidden="true">→</span>
        </button>
      </section>

      {/* --- FEATURE GRID --- */}
      <section className='w-full xs:px-[32px] px-[16px] pb-[80px] lg:px-[64px] 2xl:max-w-[1440px] 2xl:mx-auto mt-[80px]'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
          {/* Card 1 */}
          <article className='bg-white p-8 lg:p-12 rounded-[12px] border-t-4 border-[#267F8D] shadow-sm flex flex-col gap-4'>
            <div className="w-12 h-12 bg-[#e9f4f6] rounded-full flex items-center justify-center text-[#267F8D] font-bold" aria-hidden="true">01</div>
            <h3 className='font-staat text-[24px] lg:text-[28px] tracking-[2px] text-[#1a1a1a]'>
              Reinforce Brand Reliability
            </h3>
            <p className='font-poppins text-[14px] lg:text-[15px] text-gray-600 leading-relaxed'>
              Place your brand front and center where buyers research. Verified testimonials provide the social proof needed to close high-intent leads instantly.
            </p>
          </article>

          {/* Card 2 */}
          <article className='bg-white p-8 lg:p-12 rounded-[12px] border-t-4 border-[#1E7D6B] shadow-sm flex flex-col gap-4'>
            <div className="w-12 h-12 bg-[#e9f4f1] rounded-full flex items-center justify-center text-[#1E7D6B] font-bold" aria-hidden="true">02</div>
            <h3 className='font-staat text-[24px] lg:text-[28px] tracking-[2px] text-[#1a1a1a]'>
              Capture More New Customers
            </h3>
            <p className='font-poppins text-[14px] lg:text-[15px] text-gray-600 leading-relaxed'>
              Convert passive visitors into loyal buyers. By displaying genuine experiences throughout your sales funnel, you remove the "fear of the unknown."
            </p>
          </article>
        </div>
      </section>
    </div>
  )
}